import React from 'react'
import { Box, Chip, CircularProgress } from '@mui/material'

export interface StepHeaderField {
  label: string
  value?: string | number | null
}

interface StepHeaderProps {
  fields: StepHeaderField[]
  loading?: boolean
}

export const StepHeader: React.FC<StepHeaderProps> = ({ fields, loading }) => {
  const visible = fields.filter((f) => f.value != null && f.value !== '')

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: 3,
        padding: '10px 16px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        marginBottom: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: '6px'
      }}
    >
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={16} />
        </Box>
      )}
      {!loading &&
        visible.map(({ label, value }) => (
          <Chip
            key={label}
            label={`${label}: ${String(value)}`}
            color='primary'
            variant='outlined'
            size='small'
            sx={{
              borderColor: '#004bb1',
              color: '#004bb1',
              fontSize: '0.8125rem',
              width: '100%'
            }}
          />
        ))}
    </Box>
  )
}
